import { render, staticRenderFns } from "./UtilPaymentProtectionLink.vue?vue&type=template&id=58e5d9da"
import script from "./UtilPaymentProtectionLink.vue?vue&type=script&lang=js"
export * from "./UtilPaymentProtectionLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports